// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__29ZUL","header":"MergedInvoice_header__Z-1iX"};